import { useState, useEffect } from "react";
import { FalImageEditor } from "./FalImageEditor";
import { Login } from "@/components/Login";
import { Loader2 } from "lucide-react";
import "./index.css";

interface AuthUser {
  username: string;
  isAdmin: boolean;
}

export function App() {
  const [user, setUser] = useState<AuthUser | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch("/api/auth/me")
      .then((res) => {
        if (res.ok) return res.json();
        throw new Error("Not authenticated");
      })
      .then((data) => setUser({ username: data.username, isAdmin: data.isAdmin }))
      .catch(() => setUser(null))
      .finally(() => setLoading(false));
  }, []);

  const handleLogout = async () => {
    await fetch("/api/auth/logout", { method: "POST" });
    setUser(null);
  };

  if (loading) {
    return (
      <div className="h-screen flex items-center justify-center">
        <Loader2 className="w-6 h-6 animate-spin text-primary" />
      </div>
    );
  }

  if (!user) {
    return <Login onLoginSuccess={(u) => setUser(u)} />;
  }

  return (
    <FalImageEditor
      username={user.username}
      isAdmin={user.isAdmin}
      onLogout={handleLogout}
    />
  );
}

export default App;
